import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) console.warn("VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set; see .env.example");

/** Browser client. All reads/writes are constrained by RLS (director/admin roles). */
export const supabase = createClient(url ?? "http://127.0.0.1:54321", anonKey ?? "missing", {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export type UserRole = "director" | "admin" | "controller";
export interface Profile {
  id: string; full_name: string; email: string | null; role: UserRole; organisation_id?: string;
}

export interface EstimateInput {
  labour?: { shiftType?: string; hours?: number; crewSize?: number; crews?: number };
  services?: { code: string; quantity?: number; hours?: number }[];
}
export interface Lead {
  id: string; created_at: string; status: string; name: string; company: string | null;
  email: string | null; phone: string | null; services: string[]; site_address: string | null;
  message?: string | null; preferred_date?: string | null;
  source: string; estimate_input?: EstimateInput | null; estimate_result: { total?: number } | null;
  /** Answers to a configurable website form beyond the columns above. */
  details?: { key: string; label: string; value: string }[] | null;
}
export interface Quote {
  id: string; quote_number: string; status: string; total: number; valid_until: string | null; created_at: string;
  pdf_path?: string | null; job_title?: string | null; client_name?: string | null;
}
// Field-services module types (bookings, crew, jobs, job packs, rate cards) live with their module.
export * from "../modules/field-types";

export type OutboxStatus = "pending" | "sent" | "failed" | "dead";
export interface OutboxItem {
  id: string; event_type: string; status: OutboxStatus; attempts: number; next_attempt_at: string; last_error: string | null; created_at: string;
}
export interface OutboxHealth {
  adapter: string; counts: Record<OutboxStatus, number>; oldestPendingAt: string | null; items: OutboxItem[];
}
